"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _Layout = require("../Layout");

var _colors = require("../theme/colors");

var useStyles = (0, _createStyles["default"])(function (theme) {
  return {
    root: {
      display: 'flex'
    },
    hovering: {
      '& .radio-inner-content': {
        transform: 'scale(.3) !important',
        opacity: 0.5
      }
    },
    checked: {
      '& $inner': {
        transform: 'scale(.7)',
        opacity: 1
      },
      '& $outer': {
        border: "1px solid ".concat(theme.palette.primary["default"])
      }
    },
    outer: {
      width: '100%',
      height: '100%',
      backgroundColor: 'transparent',
      borderRadius: '50%',
      border: "1px solid ".concat(_colors.blueGray300)
    },
    inner: {
      transition: theme.transition.create('transform'),
      borderRadius: '50%',
      width: '100%',
      height: '100%',
      transform: 'scale(0)',
      backgroundColor: theme.palette.primary["default"]
    },
    disabled: {
      '& $inner': {
        transform: 'scale(1)',
        opacity: 1,
        backgroundColor: _colors.gray100
      },
      '&$checked': {
        '& $inner': {
          transform: 'scale(.7)',
          backgroundColor: _colors.gray300
        }
      },
      '& $outer': {
        border: "1px solid ".concat(_colors.gray300)
      }
    }
  };
});
exports.useStyles = useStyles;

var RadioIcon = function RadioIcon(_ref) {
  var _cn;

  var className = _ref.className,
      checked = _ref.checked,
      isHovering = _ref.isHovering,
      disabled = _ref.disabled;
  var classes = useStyles();
  var isActivelyHovering = isHovering && !checked && !disabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, (_cn = {}, (0, _defineProperty2["default"])(_cn, classes.checked, checked), (0, _defineProperty2["default"])(_cn, classes.hovering, isActivelyHovering), (0, _defineProperty2["default"])(_cn, classes.disabled, disabled), _cn), className),
    "data-qa": "radio-icon"
  }, /*#__PURE__*/_react["default"].createElement(_Layout.Section, {
    justify: "center",
    align: "center",
    className: classes.outer
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('radio-inner-content', classes.inner)
  })));
};

RadioIcon.displayName = 'RadioIcon';
var _default = RadioIcon;
exports["default"] = _default;